var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgProvider1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "160px",
    viewBox: "0 0 160 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "svg/persona02_blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "styleguide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI_navigation",
    transform: "translate(-197.000000, -2398.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "persona02_blue",
    transform: "translate(197.000000, 2398.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#117093",
    x: 0,
    y: 0,
    width: 160,
    height: 160,
    rx: 80
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(34.000000, 25.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,134.533333 L0,98.5 C-2.33342044e-15,79.4461761 15.4461761,64 34.5,64 L34.5,64 L34.5,64 L46,87.0373984 L57.5,64 C76.5538239,64 92,79.4461761 92,98.5 L92,134.533333 L92,134.533333",
    id: "Path-3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 46,
    cy: 28,
    r: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9930801,119.440825 L24.3670753,119.444575 L24.3733397,110.024599 C24.3767849,104.843986 28.5756371,100.645128 33.75625,100.641675 C38.9279534,100.638227 43.1232419,104.827927 43.1266891,109.99963 C43.1266918,110.003787 43.1266918,110.007943 43.1266891,110.012099 L43.1204247,119.432075 L43.1204247,119.432075 L37.4944199,119.435825",
    id: "Path-5",
    transform: "translate(33.750000, 110.040000) rotate(-15.000000) translate(-33.750000, -110.040000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,66 C25,78 27,89.6666667 31,101",
    id: "Path-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,66 C63.8888889,78.6666667 65.2222222,88 67,94",
    id: "Path-6",
    transform: "translate(65.000000, 80.000000) scale(-1, 1) translate(-65.000000, -80.000000) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 62.5,
    cy: 98.5,
    r: 4.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProvider1);
export default __webpack_public_path__ + "static/media/img-provider1.aa9c7924c04ca7304f99b6fa36e65b17.svg";
export { ForwardRef as ReactComponent };